<template>
  <div>
    <div class="profile base-height">
      <section class="me">
        <div class="profile-img">
          <img src="@/assets/images/icon-male.png" />
        </div>
        <p>{{ userInfo.username }}</p>
        <em>{{ userInfo.email }}</em>
        <div class="point">
          <div>
            <span class="material-icons"> monetization_on </span>
            <p>
              {{
                userInfo.point == 0 || userInfo.point == undefined
                  ? 0
                  : userInfo.point
              }}
              P
            </p>
          </div>
        </div>
      </section>
      <div class="right">
        <div class="tabbar">
          <!-- <button>녹음파일</button> -->
          <button
            :class="{ active: page == 1 ? true : false }"
            @click="handleButton(1)"
          >
            파일
          </button>
          <button
            :class="{ active: page == 2 ? true : false }"
            @click="handleButton(2)"
          >
            결제내역
          </button>
        </div>
        <section class="item">
          <div v-if="page == 1" class="item-list noise">
            <h2>잡음제거 리스트</h2>
            <div v-if="files.length > 0" class="list">
              <table class="module-table lineRow">
                <tr>
                  <th scope="col" width="8%">No</th>
                  <th scope="col" width="20%">제목</th>
                  <th scope="col" width="12%">종류</th>
                  <th scope="col" width="12%">생성날짜</th>
                  <th scope="col" width="12%">size(byte)</th>
                  <th scope="col" width="12%">type</th>
                  <th scope="col" width="8%">channel</th>
                  <th scope="col"></th>
                </tr>
                <tr v-for="(item, i) in files" :key="i">
                  <td>{{ i + 1 }}</td>
                  <td class="item-title">{{ item.filename }}</td>
                  <td>{{ item.kind }}</td>
                  <td>{{ moment(item.created_at).format("YYYY.MM.DD") }}</td>
                  <td>{{ item.size }}</td>
                  <td>{{ item.type }}</td>
                  <td>{{ item.channel }}</td>
                  <td>
                    <!-- <button type="button" class="btn">play</button> -->
                    <button
                      type="button"
                      class="btnView"
                      @click="handleDelete(item._id, item.filename)"
                    >
                      delete
                    </button>
                    <a type="button" class="btnDown" :href="item.url" download>
                      <i class="large material-icons">download</i>
                    </a>
                  </td>
                </tr>
              </table>
            </div>
            <div v-else class="noData">저장된 파일이 없습니다.</div>
          </div>
          <div v-if="page == 2" class="item-list payment">
            <h2>결제내역</h2>
            <div v-if="charges.length > 0" class="list">
              <table class="module-table lineRow">
                <tr>
                  <th scope="col">No</th>
                  <th scope="col">금액</th>
                  <th scope="col">결제일</th>
                  <th scope="col">종류</th>
                  <th scope="col">포인트</th>
                </tr>
                <tr v-for="(item, i) in charges" :key="i">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item.amount }}$</td>
                  <td>
                    {{ moment(item.created_at).format("YYYY.MM.DD HH:MM") }}
                  </td>
                  <td>
                    {{
                      item.serviceCode == "100"
                        ? "TRIAL"
                        : item.serviceCode == "101"
                        ? "BASIC"
                        : item.serviceCode == "102"
                        ? "PREMIUM"
                        : ""
                    }}
                  </td>
                  <td>
                    {{
                      item.amount == 1 ? 10000 : item.amount == 10 ? 100000 : ""
                    }}
                    Point
                  </td>
                </tr>
              </table>
            </div>
            <div v-else class="noData">결제 내역이 없습니다.</div>
          </div>
        </section>
        <!-- <div class="paginate">
          <a href=""><i class="material-icons">keyboard_arrow_left</i></a>
          <a href="" class="active">1</a>
          <a href="">2</a>
          <a href="">3</a>
          <a href="">4</a>
          <a href="">5</a>
          <a href=""><i class="material-icons">keyboard_arrow_right</i></a>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { fetchFileList, deleteFile } from "@/api/index";
import { fetchUserCharges } from "@/api/checkout";
import { eventBus } from "@/main";
import Player from "@/components/Player";
import moment from "moment";
import { mapState } from "vuex";
export default {
  name: "home",
  components: { Player },
  data() {
    return {
      moment: moment,
      visible: false,
      files: [],
      charges: [],
      page: 1,
    };
  },
  computed: {
    sounds() {
      return this.$store.state.sounds;
    },
    ...mapState(["userInfo"]),
  },
  created() {
    window.console.log("userInfo", this.userInfo.point);
  },
  mounted() {
    eventBus.$on("closeModal", () => {
      this.closeModal();
    });
    this.getFileList();
    this.getChargeList();
    window.console.log("userInfo", this.userInfo.point);
  },
  methods: {
    closeModal() {
      this.visible = false;
    },
    handlePlayer(item) {
      this.visible = true;
      this.item = item;
    },
    handleButton(type) {
      this.page = type;
    },
    async deleteSound(sound) {
      await this.$store.dispatch("deleteSound", sound);
      this.$store.dispatch("loadSounds");
    },
    handleDelete(id, path) {
      window.console.log("handleDelete");

      deleteFile(id, path).then((res) => {
        window.console.log("handleDelete", res);
        if (res.status == 200) {
          this.getFileList();
        } else {
          return alert(res.data.message);
        }
      });
    },
    getFileList() {
      let params = {
        page: this.currentPage,
      };
      fetchFileList(params).then((res) => {
        window.console.log("res", res);
        if (res.status == 200) {
          this.files = res.data.data;
        } else {
          return alert(res.data.message);
        }
      });
    },
    getChargeList() {
      fetchUserCharges().then((res) => {
        if (res.status == 200) {
          this.charges = res.data.data;
        } else {
          return alert(res.data.message);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.profile {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  max-width: 1200px;
  .me {
    margin: 100px auto;
    padding: 40px 0;
    width: 30%;
    border-radius: 3px;
    box-shadow: rgba(41, 42, 43, 0.08) 0px 2px 6px;
    text-align: center;
    border: 1px solid #fafafa;
    .profile-img {
      margin: 16px auto;
      img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
      }
    }
    em {
      margin: 20px 0;
      font-size: 1.3rem;
      color: #999;
    }
    .point {
      position: relative;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      padding: 20px 0;
      margin: 30px 0;
      display: flex;
      font-weight: 500;
      justify-items: center;
      justify-content: space-around;
      span {
        color: #777;
      }
      p {
        color: #444;
      }
    }
  }
  .right {
    width: 65%;
    margin: 100px auto;
    .tabbar {
      width: 100%;
      height: 40px;
      border: 1px solid #000;
      display: flex;
      justify-content: space-between;
      // border-radius: 4px;
      button {
        flex-grow: 1;
        color: #313da1;
        height: 100%;
      }
      button:nht-child(2) {
        border-right: 1px solid #000;
      }
      .active {
        background: #000;
        color: #fff;
      }
    }
    .item {
      width: 100%;
      overflow-x: auto;
      white-space: nowrap;
      .item-list {
        margin-top: 50px;
        h2 {
          font-size: 1.8rem;
          font-weight: bold;
          letter-spacing: 1;
          margin: 40px 0 20px 20px;
          color: #313da1;
        }
        .list {
          width: 100%;
          table {
            width: 100%;
            border-collapse: separate;
            border-spacing: 0 5px;
            table-layout: fixed;
            tr {
              height: 45px;
              box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
              font-size: 12.5px;
              td {
                border: none;
                padding: 6px;
                button {
                  border-radius: 25px;
                  background: #000;
                  color: #fff;
                  height: 25px;
                  width: 65px;
                  margin: 0 3px;
                  display: inline-block;
                }
                .btn {
                  background: #181818;
                }
                .btnView {
                  background: #ff5252;
                }
                .btnDown {
                  display: inline-block;
                  width: 25px;
                  background: none;
                  border-radius: 0;
                  padding: 1px 3px;
                  vertical-align: top;
                  i {
                    color: #313da1;
                    font-size: 25px;
                  }
                }
              }
              .item-title {
                text-overflow: ellipsis;
                white-space: pre-line;
                text-align: left;
              }
              th {
                background: none;
                border: none;
                font-weight: 500;
                color: #fff;
              }
            }
            tr:nth-child(1) {
              background: #313da1;
              box-shadow: none;
              border-radius: 5px;
            }
          }
        }
      }
      .recording {
        display: none;
      }
    }
    .paginate {
      height: 50px;
      width: 70%;
      margin: 40px auto;
      text-align: center;
      display: flex;
      justify-content: space-evenly;
      a {
        width: 30px;
        height: 30px;
        line-height: 30px;
        i {
          font-size: 25px;
          vertical-align: middle;
          line-height: 0;
        }
      }
      a.active {
        background: #313da1;
        color: #fff;
        font-weight: 500;
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .profile {
    width: calc(100% - 30px);
    .me {
      margin: 0;
      margin-top: 30px;
      width: 100%;
      border: 0px;
      box-shadow: none;
      .point {
        padding: 20px 0;
        margin: 30px 0 0;
      }
      .profile-img {
        margin: 0 auto;
      }
    }
    .right {
      width: 100%;
      margin: 0 auto;
      .item {
        margin: 0;
        .item-list {
          margin-top: 30px;
          h2 {
            margin: 0;
          }
          .list {
            width: 100%;
          }
        }
      }
      .paginate {
        height: 50px;
        width: 100%;
        margin-top: 40px;
        text-align: center;
        a {
          width: 30px;
          height: 30px;
          i {
            font-size: 25px;
          }
        }
        a.active {
          background: #313da1;
          color: #fff;
          font-weight: 500;
        }
      }
    }
  }
}
@media screen and (max-width: 769px) {
  .profile {
    width: calc(100% - 20px);
    .me {
      width: 100%;
    }
    .item {
      .item-list {
        min-width: 700px;
        margin-top: 30px;
        h2 {
          margin: 0 auto;
        }
        .list {
          width: 100%;
        }
      }
    }
    .paginate {
      width: 100%;
      margin-top: 20px;
      a {
        text-align: center;
      }
    }
  }
}
.noData {
  text-align: center;
}
</style>
